/* tslint:disable */
import {
  NotificationChain,
  Notification
} from '../index';

declare var Object: any;
export interface ChainNotificationMappingInterface {
  "id"?: any;
  "chainId"?: any;
  "notificationId"?: any;
  "created"?: Date;
  chain?: NotificationChain;
  notification?: Notification;
}

export class ChainNotificationMapping implements ChainNotificationMappingInterface {
  "id": any;
  "chainId": any;
  "notificationId": any;
  "created": Date;
  chain: NotificationChain;
  notification: Notification;
  constructor(data?: ChainNotificationMappingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ChainNotificationMapping`.
   */
  public static getModelName() {
    return "ChainNotificationMapping";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ChainNotificationMapping for dynamic purposes.
  **/
  public static factory(data: ChainNotificationMappingInterface): ChainNotificationMapping{
    return new ChainNotificationMapping(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ChainNotificationMapping',
      plural: 'ChainNotificationMappings',
      path: 'ChainNotificationMappings',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'any'
        },
        "chainId": {
          name: 'chainId',
          type: 'any'
        },
        "notificationId": {
          name: 'notificationId',
          type: 'any'
        },
        "created": {
          name: 'created',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        chain: {
          name: 'chain',
          type: 'NotificationChain',
          model: 'NotificationChain',
          relationType: 'belongsTo',
                  keyFrom: 'chainId',
          keyTo: 'id'
        },
        notification: {
          name: 'notification',
          type: 'Notification',
          model: 'Notification',
          relationType: 'belongsTo',
                  keyFrom: 'notificationId',
          keyTo: 'id'
        },
      }
    }
  }
}
